{
    "locale": "it-IT",
    "General": {
        "OrText": "Oppure",
        "Title_MyHubert": "My Hubert",
        "Button_GoTo_MyHubert": "Vai su My Hubert"
    },
    "Header": {
        "ButtonText_CreateNewAccount": "Crea un nuovo account",
        "ButtonText_SignInToYourAccount": "Accedi al tuo account",
        "ButtonText_StartInterviewWithoutSigningUp": "Inizia il colloquio senza registrarti",
        "ButtonText_StartInterviewWithoutSigningIn": "Inizia il colloquio senza accedere",
        "Navlink_Dashboard": "Dashboard",
        "Navlink_MyInterviews": "I miei colloqui",
        "Navlink_LearnWithHubert": "Impara con Hubert",
        "Navlink_HelpCenter": "Centro assistenza",
        "MyProfile": "Il mio profilo",
        "LogOut": "Esci"
    },
    "Login": {
        "MainTitle": "Visualizza i risultati del tuo colloquio con Hubert",
        "Subtitle": "Accedi per vedere i risultati, ricevere feedback, leggere consigli e molto altro.",
        "LoginTitle": "Accedi al tuo account Hubert",
        "Label_Email": "Email",
        "Label_Password": "Password",
        "ButtonText_SignIn": "Accedi",
        "ButtonText_ForgotPassword": "Hai dimenticato la password?",
        "ButtonText_ContinueWithGoogle": "Continua con Google",
        "OrSeparator": "Oppure",
        "Error_Email_Required": "L’email è obbligatoria.",
        "Error_Email_Invalid": "Inserisci un’email valida.",
        "Error_Password_Required": "La password è obbligatoria.",
        "Error_Use_Same_Email_As_Interview": "Usa la stessa email che hai indicato durante il colloquio."
    },
    "Registration": {
        "MainTitle": "Visualizza i risultati del tuo colloquio con Hubert",
        "Subtitle": "Registrati per vedere i risultati, ricevere feedback, leggere consigli e molto altro.",
        "RegistrationTitle": "Crea un account Hubert",
        "BenefitsBox_Title": "Puoi",
        "BenefitsBox_Point1": "Accedere allo storico dei tuoi colloqui",
        "BenefitsBox_Point2": "Ricevere feedback sui tuoi colloqui",
        "BenefitsBox_Point3": "Riutilizzare le risposte in nuovi colloqui",
        "BenefitsBox_Point4": "Ricevere consigli per i colloqui",
        "BenefitsBox_Point5": "Leggere guide di carriera",
        "BenefitsBox_Point6": "E molto altro",
        "Label_FirstName": "Nome",
        "Label_LastName": "Cognome",
        "Label_Email": "Email",
        "Label_Password": "Password",
        "Label_PhoneNumber": "Numero di telefono",
        "Label_TermsOfService": "Accetto la",
        "Label_TermsOfServiceLink": "Informativa sulla privacy e Termini e condizioni",
        "Placeholder_CountryCode": "Seleziona il prefisso",
        "Placeholder_PhoneNumber": "Es. 3201234567",
        "HelpText_Password": "La password deve contenere almeno 6 caratteri.",
        "ButtonText_SignUp": "Registrati",
        "ButtonText_SignUpWithGoogle": "Registrati con Google",
        "OrSeparator": "Oppure",
        "Error_FirstName_Required": "Il nome è obbligatorio.",
        "Error_LastName_Required": "Il cognome è obbligatorio.",
        "Error_Email_Required": "L’email è obbligatoria.",
        "Error_Email_Invalid": "Inserisci un’email valida.",
        "Error_Email_Exists": "Questa email è già in uso.",
        "Error_Password_Required": "La password è obbligatoria.",
        "Error_Password_6_Characters": "La password deve contenere almeno 6 caratteri.",
        "Error_PhoneNumber_Required": "Il numero di telefono è obbligatorio.",
        "Error_PhoneNumber_Invalid": "Il numero di telefono non è valido.",
        "Error_PrivacyPolicyCheck_Required": "Devi accettare Informativa sulla privacy e Termini e condizioni."
    },
    "RegistrationInviteEmail": {
        "Subtitle_BeforeInterviewCompleted": "Per sostenere il colloquio, accetta i termini e le condizioni per usare Hubert. Spunta la casella per continuare.",
        "Subtitle_AfterInterviewCompleted": "Registrati per vedere i risultati, ricevere feedback, leggere consigli e molto altro.",
        "PrivacyPolicyText": "Premendo Registrati accetti l'",
        "PrivacyPolicyLink": " Informativa sulla privacy e Termini e condizioni",
        "ButtonText_SignUp": "Registrati e vai al colloquio",
        "ButtonText_SignUpNormal": "Registrati",
        "ButtonText_SignInInstead": "Clicca qui per accedere"
    },
    "LoginInviteEmail": {
        "Subtitle": "Accedi per vedere i risultati, ricevere feedback, leggere consigli e molto altro."
    },
    "AppMessages": {
        "internal-server-error": "Si è verificato un errore imprevisto.",
        "invalid-credentials": "Credenziali non valide. Riprova.",
        "user-not-found": "Credenziali non valide. Riprova.",
        "account-not-found": "Account non valido. Riprova.",
        "verify-email-title": "Verifica la tua email",
        "verify-email-subtitle": "Controlla la tua email per verificare l’account.",
        "email-not-verified-title": "Email non verificata",
        "email-not-verified-subtitle": "Controlla la tua email per verificare l’account.",
        "verifying-email-title": "Verifica dell’email",
        "verifying-email-subtitle": "Attendi...",
        "sign-in-title": "Accesso in corso",
        "sign-in-subtitle": "Attendi...",
        "server-error": "Qualcosa è andato storto.",
        "hubert-user-exists": "L’account esiste già.",
        "account-exists": "L’account esiste già.",
        "email-verified": "La tua email è stata verificata.",
        "email-is-taken": "Questa email è già in uso.",
        "re-enter-password": "Usa la tua password per accedere",
        "password-reset": "La tua password è stata cambiata.",
        "re-enter-new-password": "Usa la nuova password per accedere",
        "invalid-invitation": "Invito non valido.",
        "invalid-code": "Codice di verifica non valido.",
        "email-already-verified": "L’email è già verificata.",
        "email-mismatch-title": "Email non corrispondono",
        "email-mismatch-subtitle": "Usa lo stesso indirizzo email che hai usato per inviare la candidatura."
    },
    "TransitionPage": {
        "loading-title": "Caricamento...",
        "loading-subtitle": "Stiamo preparando i tuoi dati...",
        "logout-title": "Caricamento...",
        "logout-subtitle": "Stiamo effettuando la disconnessione..."
    },
    "ImpersonationPage": {
        "loading-title": "Caricamento...",
        "loading-subtitle": "Stiamo preparando i tuoi dati..."
    },
    "ProcessInvitation": {
        "loading-title": "Caricamento...",
        "loading-subtitle": "Attendi mentre carichiamo il tuo colloquio.",
        "InvitationNotFound": "Non riusciamo a trovare il tuo colloquio.",
        "InvitationExpired": "Questo link per accedere al colloquio è scaduto.",
        "InvitationExpired_Description1": "Apri il colloquio da",
        "InvitationExpired_Description2": "oppure contatta il tuo recruiter.",
        "InvitationInvalid": "Il link a questo invito non è valido.",
        "InterviewCompleted": "Hai già completato questo colloquio."
    },
    "Common": {
        "MyInterviews": {
            "Title": "I miei colloqui",
            "TableHead_Employer": "Azienda",
            "TableHead_Job": "Ruolo",
            "TableHead_Status": "Stato",
            "TableHead_ApplicationDate": "Data candidatura",
            "TableBody_StartInterview": "Non hai completato il colloquio. Clicca qui per iniziare o riprendere il colloquio.",
            "TableBody_NotScored": "Colloquio completato. I risultati saranno disponibili a breve.",
            "TableBody_Details": "Clicca qui per vedere i risultati e altro.",
            "ApplicationDate_Invited": "Invitato",
            "ApplicationDate_MinuteAgo": "minuto fa",
            "ApplicationDate_MinutesAgo": "minuti fa",
            "ApplicationDate_HourAgo": "ora fa",
            "ApplicationDate_HoursAgo": "ore fa",
            "ApplicationDate_DayAgo": "giorno fa",
            "ApplicationDate_DaysAgo": "giorni fa",
            "ButtonText_SeeAllInterviews": "Vedi tutti i colloqui",
            "ButtonText_Details": "Dettagli",
            "ButtonText_StartInterview": "Vai al colloquio",
            "ButtonText_NotScored": "In attesa dei risultati",
            "NoInterviews_Message": "Non risultano colloqui passati o programmati."
        },
        "LatestJobPostings": {
            "NoJobPostings": "Al momento non ci sono offerte di lavoro. Riprova più tardi."
        }
    },
    "Dashboard": {
        "MyCareer": {
            "Title": "La mia carriera",
            "Subtitle": "Seleziona un colloquio per vedere la valutazione e le tue prospettive.",
            "MostRecentInterview": "Colloquio più recente",
            "ToDo": "Da fare",
            "NoOngoingInterviews_Title": "Ancora nessun nuovo invito a un colloquio.",
            "NoOngoingInterviews_Subtitle": "Nuovi colloqui Hubert compariranno qui quando saranno programmati dai recruiter.",
            "NoRecentInterviews_Title": "Nessun colloquio precedente trovato.",
            "NoRecentInterviews_Subtitle": "Quando riceverai un invito a un colloquio, comparirà qui sotto.",
            "ButtonText_StartInterview": "Vai al colloquio",
            "ButtonText_NotScored": "In attesa di risultati",
            "ButtonText_Details": "Dettagli"
        },
        "LearnWithHubert": {
            "Title": "Impara con Hubert",
            "Subtitle": "Ricevi consigli per migliorare i tuoi colloqui e le tue performance al lavoro.",
            "PickedForMe": "Ultimi articoli",
            "ButtonText_SeeAllArticles": "Vedi tutti gli articoli"
        },
        "HubertTip": {
            "Title": "Consiglio di Hubert",
            "Subtitle": "Sostieni i colloqui più velocemente",
            "Description": "Ti stai candidando a un nuovo lavoro in un ruolo simile a uno per cui hai già fatto un colloquio con Hubert? Puoi riutilizzare le risposte di quel colloquio per risparmiare tempo.",
            "ButtonText_ReadMoreTips": "Leggi altri consigli"
        },
        "NewCandidateModalPopup": {
            "Title": "È tutto pronto!",
            "DescriptionLine1": "Il tuo account è pronto.",
            "DescriptionLine2": "Gestisci colloqui e profilo. Visualizza i risultati, ricevi feedback e scopri come affrontare al meglio i colloqui.",
            "ButtonText_LetsGo": "Andiamo"
        },
        "InterviewCompletedModal": {
            "Title": "Complimenti!",
            "Subtitle": "Hai completato il colloquio.",
            "Description": "Il team di recruiting esaminerà tutte le candidature e ti fornirà un aggiornamento via email o telefono non appena possibile.",
            "ButtonText_Continue": "Continua"
        },
        "LatestJobPostings": {
            "Title": "Ultime offerte di lavoro",
            "Subtitle": "Scopri altre opportunità dei partner di Hubert pubblicate di recente."
        }
    },
    "MyInterviews": {
        "MyInterviewsSection_Title": "I miei colloqui",
        "MyInterviewsSection_Subtitle": "Seleziona un colloquio per vedere la valutazione e le tue opportunità di carriera.",
        "MyInterviewsSection_ToDo": "Da fare"
    },
    "Interview": {
        "ButtonText_SeeAllInterviews": "Vedi tutti i colloqui",
        "InterviewNotFound_Title": "Colloquio non accessibile",
        "InterviewNotFound_Description": "Stai tentando di accedere ai dettagli di un colloquio non associata al tuo account.",
        "ButtonText_GoToAllInterviews": "Vai ai miei colloqui",
        "InterviewDetails": {
            "Title": "Dettagli del colloquio",
            "ForRole": "Per il ruolo",
            "InterviewCompletedOn": "Colloquio completato il {{date}} alle {{time}}"
        },
        "MyResult": {
            "Title": "Il mio risultato",
            "Subtitle": "Compatibilità valutata",
            "ButtonText_LearnMore": "Scopri come vengono valutate le tue risposte",
            "GotPotential_Title": "Ottimo potenziale, manca un requisito",
            "GotPotential_Description": "Le tue risposte mostrano un ottimo potenziale per questo tipo di ruolo. Tuttavia, da questo colloquio sembra che ti manchi uno o più requisiti richiesti per la posizione. Questo può influire sui prossimi step, in base alle esigenze del recruiter e al numero di candidati. Se non vieni selezionato per la fase successiva, non significa che non abbia riconosciuto il tuo potenziale come candidato. Spesso si tratta semplicemente di una mancata corrispondenza con le esigenze specifiche del ruolo. Dai un’occhiata ad altre opportunità e ai consigli di miglioramento qui sotto.",
            "GotPotential_DescriptionSecondary": "La valutazione di Hubert è indicativa. La decisione finale spetta al recruiter e anche altri fattori, come il numero di candidati, possono influire sull’esito.",
            "GreatMatch_Title": "Ottima corrispondenza",
            "GreatMatch_Description": "Le tue risposte erano ben allineate con ciò che i recruiter cercano tipicamente per questo ruolo e soddisfi i requisiti della posizione. Ottimo lavoro. Il recruiter esaminerà tutti i candidati e deciderà i prossimi step.",
            "GreatMatch_DescriptionSecondary": "La valutazione di Hubert è indicativa. La decisione finale spetta al recruiter e anche altri fattori, come il numero di candidati, possono influire sull’esito. Se non vieni selezionato per la fase successiva, non significa che non abbia riconosciuto il tuo potenziale come candidato. Spesso si tratta semplicemente di una mancata corrispondenza con le esigenze specifiche del ruolo. Dai un’occhiata ad altre opportunità e ai consigli di miglioramento qui sotto.",
            "OkMatch_Title": "Idoneo, aggiungi più impatto",
            "OkMatch_Description": "Soddisfi i requisiti della posizione. Per distinguerti maggiormente, le tue risposte potrebbero essere più chiare e specifiche rispetto a quelle che i recruiter ricevono di solito per questo ruolo. Rivedi le tue risposte qui sotto: un esempio concreto e un risultato misurabile possono aumentare il punteggio.",
            "OkMatch_DescriptionSecondary": "La valutazione di Hubert è indicativa. La decisione finale spetta al recruiter e anche altri fattori, come il numero di candidati, possono influire sull’esito.",
            "NotClearMatch_Title": "Forse non è ancora il momento giusto",
            "NotClearMatch_Description": "Dalle risposte fornite in questo colloquio, emerge una minore aderenza rispetto a ciò che il recruiter cerca per questo ruolo, oppure potresti non soddisfare alcuni requisiti chiave. Se vuoi migliorare, rivedi le domande qui sotto: maggiore specificità, azioni chiare e risultati concreti possono fare la differenza.",
            "NotClearMatch_DescriptionSecondary": "La valutazione di Hubert è indicativa. La decisione finale spetta al recruiter e anche altri fattori, come il numero di candidati, possono influire sull’esito."
        },
        "ScoreBox": {
            "ProfessionalExperiences": "Esperienze professionali, motivazioni e competenze",
            "QualifyingRequirements": "Requisiti qualificanti per questa posizione",
            "NotQualified_Title": "Da migliorare",
            "NotQualified_Description": "Le tue risposte potrebbero essere state meno specifiche o orientate ai risultati rispetto a quanto il recruiter si aspetta per questo ruolo. Qui sotto trovi le aree in cui aggiungere un esempio concreto, azioni specifiche o un risultato chiaro può rafforzare la tua risposta.",
            "GreatResults_Title": "Risposte solide",
            "GreatResults_Description": "Le tue risposte indicano una buona affinità con questo tipo di ruolo e una comunicazione chiara. Se ci sono risposte che possono essere migliorate, le troverai evidenziate qui sotto.",
            "MeetingRequirements_Title": "Requisiti soddisfatti",
            "MeetingRequirements_Description": "Le tue risposte indicano che soddisfi i requisiti qualificanti impostati per questa posizione. È un’ottima base.",
            "NotAllExpectationsMet_Title": "Mancano uno o più requisiti",
            "NotAllExpectationsMet_Description": "In base alle tue risposte, potresti non soddisfare uno o più requisiti qualificanti per questa specifica posizione, come certificati, licenze, livello di istruzione o anni di esperienza.",
            "ButtonText_FindOutPossibleReasons": "Vedi dettagli"
        },
        "ScriptFromInterview": {
            "Title": "Leggi il colloquio completo",
            "ButtonText_SeeWholeTranscript": "Leggi il colloquio",
            "ButtonText_DeleteInterview": "Elimina colloquio",
            "Loading_Title": "Caricamento...",
            "Loading_Subtitle": "Attendi mentre carichiamo la trascrizione del colloquio."
        },
        "HowToImproveAtInterviews": {
            "Title": "Come migliorare nei colloqui",
            "Subtitle_Questions": "Ecco alcune domande in cui la tua risposta potrebbe migliorare.",
            "Subtitle_NoQuestions": "Nessuna risposta specifica è stata segnalata. Ecco i modi migliori per aggiungere impatto per questo ruolo.",
            "GreatMatch_Questions_Description": "Segui le istruzioni prima di ogni domanda. Usa un solo esempio e raccontalo così: contesto → azioni → risultato. Evita risposte troppo brevi (tipo “OK”) o troppo lunghe: punta a 3–6 frasi chiare e concrete, come in un colloquio di persona.",
            "GreatMatch_NoQuestions_Description": "Hai risposto bene alle domande. Ottimo lavoro.",
            "OkMatch_Questions_Description": "Qui sotto trovi le domande in cui puoi aumentare l’impatto delle tue risposte. Segui le indicazioni e usa un solo esempio strutturato: contesto → azioni → risultato. Evita risposte troppo brevi (come “OK”) o eccessivamente lunghe: punta a 3–6 frasi chiare e concrete.",
            "OkMatch_NoQuestions_Description": "Le tue risposte sono buone, ma per questo ruolo la competizione può essere alta. In questi casi, anche risposte solide possono posizionarsi nella parte centrale della valutazione.",
            "OkMatch_NoQuestions_DescriptionSecondary": "La prossima volta punta su chiarezza e impatto. Parti dal risultato, aggiungi un esempio reale e resta sintetico: di solito 3–6 frasi. Sii specifico su cosa hai fatto, come l’hai fatto e cosa è cambiato grazie a te.",
            "GotPotential_Questions_Description": "Anche con un ottimo potenziale, alcune risposte possono essere rese più incisive. Segui le istruzioni e usa un solo esempio: contesto → azioni → risultato. Evita risposte troppo brevi (tipo “OK”) o troppo lunghe: punta a 3–6 frasi chiare e concrete.",
            "GotPotential_NoQuestions_Description": "Non abbiamo trovato risposte che richiedano miglioramenti importanti su competenze professionali e motivazioni. Su questi temi sembri aver risposto bene.",
            "NotClearMatch_Questions_Description": "Qui sotto trovi le domande in cui puoi migliorare. Segui le istruzioni e usa un solo esempio: contesto → azioni → risultato. Evita risposte troppo brevi (tipo “OK”) o troppo lunghe: punta a 3–6 frasi chiare e concrete.",
            "NotClearMatch_NoQuestions_Description": "Non c’è una singola risposta “sbagliata”. Si tratta più di un allineamento con i requisiti di questo ruolo. Quando la concorrenza è alta, anche piccole differenze possono fare la differenza.",
            "NotClearMatch_NoQuestions_DescriptionSecondary": "Per il prossimo colloquio, sii concreto: un esempio per domanda, azioni chiare e risultato. Breve e specifico di solito batte lungo e generico.",
            "Alert_WantMoreAdvice": "Vuoi altri consigli su come fare bene in un colloquio Hubert?",
            "AlertLink_ExploreOurGeneralAdviceArticle": "Esplora il nostro articolo con consigli generali"
        },
        "SimilarOffers": {
            "Title": "Offerte simili"
        },
        "HowHubertScoresInterviews": {
            "Title": "Come valuta Hubert i colloqui?",
            "Description": "Qui sotto trovi una breve descrizione di come Hubert valuta le risposte a colloqui. Abbiamo anche aggiunto una sezione chiamata Processo di selezione per spiegare quali sono i prossimi step dopo il colloquio con Hubert.",
            "Tabs_PossibleOutcomes": "Possibili esiti",
            "Tabs_RecruitmentProcess": "Processo di selezione",
            "AssessedMatch_Title": "Compatibilità valutata",
            "AssessedMatch_Description": "Hubert valuta come risultano complessivamente le tue risposte rispetto a ciò che i recruiter cercano tipicamente per questo ruolo. Insieme ai requisiti della posizione, vedrai uno degli esiti qui sotto.",
            "AssessedMatch_DescriptionSecondary": "La valutazione di Hubert è indicativa. La decisione finale spetta al recruiter e anche altri fattori, come il numero di candidati, possono influire sull’esito.",
            "GreatMatch_Title": "Ottima corrispondenza",
            "GreatMatch_Description": "Le tue risposte erano ben allineate con ciò che i recruiter cercano tipicamente per questo ruolo e soddisfi i requisiti della posizione. Ottimo lavoro. Il recruiter esaminerà tutti i candidati e deciderà i prossimi step.",
            "GotPotential_Title": "Ottimo potenziale, manca un requisito",
            "GotPotential_Description": "Le tue risposte indicano un ottimo potenziale per questo tipo di ruolo. Tuttavia, in base a questo colloquio, potresti non soddisfare uno o più requisiti richiesti per questa specifica posizione. Questo può influire sui prossimi step, a seconda delle esigenze del recruiter e del bacino complessivo di candidati.",
            "OkMatch_Title": "Idoneo, aggiungi più impatto",
            "OkMatch_Description": "Soddisfi i requisiti della posizione. Per distinguerti, le tue risposte potrebbero aver bisogno di maggiore chiarezza e specificità rispetto a ciò che i recruiter vedono tipicamente per questo ruolo. Usa il feedback nel tuo colloquio per rafforzare esempi e risultati in futuro.",
            "NotClearMatch_Title": "Forse non è ancora il momento giusto",
            "NotClearMatch_Description": "In base a questo colloquio, le tue risposte potrebbero essere meno allineate con ciò che il recruiter cerca per questo ruolo, oppure potresti non soddisfare alcuni requisiti. Rivedi le tue risposte per individuare dove puoi aggiungere maggiore chiarezza, esempi concreti e risultati misurabili.",
            "ProfessionalExperiences_Title": "Esperienze professionali, motivazioni e competenze",
            "ProfessionalExperiences_Description": "Sono domande sulle tue esperienze precedenti, la tua motivazione per il ruolo e le competenze rilevanti. I recruiter decidono quali domande usare nel colloquio per la specifica posizione.",
            "GreatResults_Title": "Risposte solide",
            "GreatResults_Description": "Le tue risposte indicano una buona affinità con questo tipo di ruolo e una comunicazione chiara. Se una risposta può essere migliorata, la troverai evidenziata nel tuo colloquio.",
            "NotQualified_Title": "Da migliorare",
            "NotQualified_Description": "Le tue risposte potrebbero essere state meno specifiche o orientate ai risultati rispetto a quanto il recruiter si aspetta per questo ruolo. Cerca i punti evidenziati in cui aggiungere un esempio concreto, le azioni che hai svolto o un risultato chiaro può rafforzare le tue risposte.",
            "QualifyingRequirements_Title": "Requisiti di base o qualificanti per questa posizione",
            "QualifyingRequirements_Description": "Sono domande sui requisiti qualificanti impostati dal recruiter per la posizione. Per esempio un certificato richiesto, una patente o un certo livello di esperienza rilevante.",
            "MeetingRequirements_Title": "Requisiti soddisfatti",
            "MeetingRequirements_Description": "Le tue risposte indicano che soddisfi i requisiti qualificanti impostati dal recruiter per questa posizione. È un’ottima base.",
            "NotAllExpectationsMet_Title": "Mancano uno o più requisiti",
            "NotAllExpectationsMet_Description": "In base alle tue risposte, potresti non soddisfare uno o più requisiti qualificanti per questa specifica posizione, come certificati, licenze, livello di istruzione o anni di esperienza.",
            "RecruitmentProcess_Title": "Processo di selezione",
            "RecruitmentProcess_Description": "Hubert è spesso il primo step nei processi con molti candidati. Tutti rispondono alle stesse domande, così il confronto è più coerente. Inoltre, Hubert non usa dati sensibili (età, genere, etnia, religione o aspetto), riducendo il rischio di bias inconsci.",
            "EventOne_Title": "Sostieni il colloquio con Hubert",
            "EventOne_Description": "Fai il colloquio con Hubert quando e dove ti è più comodo. Non ci sono limiti di tempo: puoi fare una pausa e riprendere da dove avevi lasciato.",
            "EventTwo_Title": "Il tuo colloquio viene valutato",
            "EventTwo_Description": "Hubert valuta le tue risposte utilizzando una tecnologia avanzata. Quando la valutazione sarà pronta, la troverai qui in My Hubert e sarà disponibile anche per il recruiter nel sistema di candidatura.",
            "EventThree_Title": "Il recruiter seleziona i candidati per gli step successivi",
            "EventThree_Description": "Il recruiter rivede le tue risposte e la valutazione (indicativa) e decide gli step successivi: può essere una telefonata, un test o un colloquio finale. A volte possono aspettare; se altri candidati sono più adatti, la candidatura può essere rifiutata.",
            "ButtonText_Close": "Chiudi"
        }
    },
    "MyProfile": {
        "Title": "Il mio profilo",
        "MyDetails": {
            "Title": "I miei dati",
            "Label_FirstName": "Nome",
            "Label_LastName": "Cognome",
            "Label_Email": "Email",
            "Label_PhoneNumber": "Numero di telefono",
            "ButtonText_UpdateDetails": "Aggiorna dati",
            "Error_FirstName_Required": "Il nome è obbligatorio.",
            "Error_LastName_Required": "Il cognome è obbligatorio.",
            "Error_Email_Required": "L’email è obbligatoria.",
            "Error_Email_Invalid": "Inserisci un’email valida.",
            "Error_PhoneNumber_Invalid": "Il numero di telefono non è valido.",
            "Success_Details_Updated": "Profilo aggiornato."
        },
        "ChangePassword": {
            "Title": "Cambia password",
            "Set_Password_Title": "Crea password",
            "Label_CurrentPassword": "Password attuale",
            "Label_NewPassword": "Nuova password",
            "Label_RepeatNewPassword": "Ripeti nuova password",
            "Alert_SignInAgain": "Accedi di nuovo per impostare la password.",
            "ButtonText_UpdatePassword": "Aggiorna password",
            "ButtonText_SetPassword": "Imposta password",
            "ButtonText_SignInAgain": "Accedi di nuovo",
            "Error_CurrentPassword_Required": "La password attuale è obbligatoria.",
            "Error_CurrentPassword_DoesntMatch": "La password non corrisponde alla password attuale.",
            "Error_NewPassword_Required": "La nuova password è obbligatoria.",
            "Error_NewPassword_6_Characters": "La nuova password deve contenere almeno 6 caratteri.",
            "Error_RepeatNewPassword_Required": "La conferma della nuova password è obbligatoria.",
            "Error_RepeatNewPassword_DoesntMatch": "La password non corrisponde alla nuova password.",
            "Success_Password_Changed": "Password aggiornata.",
            "Error_Invalid_CurrentPassword": "Password attuale non valida."
        },
        "NotificationPreferences": {
            "Title": "Preferenze notifiche",
            "Label_ReceiveUpdatesToggle": "Voglio ricevere aggiornamenti da Hubert.",
            "Label_ReceiveUpdatesToggleHelpText": "Riceverai guide di carriera, consigli per i colloqui e altro."
        },
        "AccountRemoval": {
            "Title": "Eliminazione account",
            "ButtonText_RemoveMyAccount": "Elimina il mio account"
        }
    },
    "PreInterviewPage": {
        "Title_Hello": "Ciao",
        "Subtitle": "Stai per iniziare il tuo colloquio di lavoro.",
        "TipBox_Title": "Ecco alcuni consigli per aiutarti a dare il meglio.",
        "TipBox_Tip1": "Fai il colloquio in un posto tranquillo, dove puoi concentrarti e scrivere comodamente.",
        "TipBox_Tip2": "Rispondi da computer con tastiera (a meno che tu non sia a tuo agio a scrivere molto da mobile).",
        "TipBox_Tip3": "Sii il più specifico e dettagliato possibile. Hubert e i recruiter vogliono conoscerti bene.",
        "TipBox_Tip4": "Prenditi il tempo che ti serve. Non ci sono limiti di tempo.",
        "TipBox_Tip5": "Puoi fare una pausa in qualsiasi momento e riprendere da dove avevi lasciato.",
        "TipBox_Tip6": "Sii te stesso e affronta il colloquio con Hubert con lo stesso impegno di un colloquio di persona.",
        "CheckAdviceArticle_Text1": "Se vuoi altri consigli su come fare bene nel colloquio, leggi questo",
        "CheckAdviceArticle_Text2": "articolo",
        "CheckAdviceArticle_Text3": "con ottimi suggerimenti.",
        "ReadyToGetStarted": "Sei pronto per iniziare?",
        "ORSeparator_Text": "Oppure",
        "ButtonText_StartInterviewNow": "Inizia subito il colloquio",
        "ButtonText_SetReminder": "Non sono pronto, imposta un promemoria",
        "PrivacyPolicyText": "Premendo Inizia colloquio accetti l'",
        "PrivacyPolicyLink": " Informativa sulla privacy e Termini e condizioni"
    },
    "InterviewCompletedPageInviteEmail": {
        "CompletedAlert_Title": "Complimenti!",
        "CompletedAlert_Subtitle": "Hai completato il colloquio.",
        "CompletedAlert_Description": "Il team di recruiting esaminerà tutte le candidature e ti fornirà un aggiornamento via email o telefono non appena possibile.",
        "InterviewNotCompleted": "Il colloquio non è stato completato."
    },
    "HelpCenter": {
        "BannerSection": {
            "Title": "Centro assistenza",
            "Subtitle": "Trova le risposte alle domande più frequenti su Hubert.",
            "Label_Search": "cerca tra le domande frequenti",
            "ButtonText_Search": "Cerca"
        },
        "FAQSection": {
            "Tabs_All": "Tutte",
            "Tabs_AboutHubertInterview": "Colloquio Hubert",
            "Tabs_TechnicalSupport": "Supporto tecnico"
        },
        "StillHaveQuestion": {
            "Title": "Hai ancora una domanda?",
            "Description": "Siamo felici di aiutarti.",
            "DropUsAEmail": "Scrivici a hubert@hubert.ai"
        },
        "Q&ATexts": {
            "AboutHubertInterview": [
                {
                    "q": "Posso sostenere il colloquio tramite telefonata?",
                    "a": "Al momento Hubert funziona solo via chat. Se hai una condizione medica che ti impedisce di svolgere il colloquio, ti invitiamo a contattare direttamente l’azienda che assume. Hubert è responsabile esclusivamente del colloquio via chat."
                },
                {
                    "q": "Posso fare il colloquio in un’altra lingua?",
                    "a": "Per alcuni colloqui è possibile scegliere la lingua all’inizio. Se questa opzione manca, è probabile che la comprensione della lingua del colloquio sia un requisito per la posizione. Per altre domande, contatta l’azienda che assume."
                },
                {
                    "q": "Sarò penalizzato se rispondo in modo breve?",
                    "a": "No, purché tu risponda in modo pertinente alle domande. Non c’è una lunghezza minima, ma i dettagli spesso aiutano."
                },
                {
                    "q": "Posso riutilizzare le risposte di un altro colloquio con Hubert?",
                    "a": "Sì, puoi riutilizzare le risposte precedenti se hai effettuato l’accesso a My Hubert e ti candidi per un ruolo simile."
                },
                {
                    "q": "Un essere umano leggerà il mio colloquio?",
                    "a": "Sì, ai nostri clienti viene chiesto di controllare manualmente i colloqui."
                },
                {
                    "q": "Ho fatto il colloquio, cosa succede adesso?",
                    "a": "Una volta completato il colloquio, i risultati vengono inviati al recruiter nel sistema di candidatura dell’azienda. Il recruiter può così rivedere le tue risposte e la valutazione di Hubert. Sulla base di quest’ultima (che è indicativa) e del proprio giudizio, decide se invitarti alla fase successiva, che può essere una telefonata, un test o un colloquio finale."
                },
                {
                    "q": "Ho una domanda sui prossimi step del processo, chi devo contattare?",
                    "a": "Contatta l’azienda presso cui ti sei candidato."
                },
                {
                    "q": "Come fate a non introdurre bias nel processo di selezione?",
                    "a": "Ridurre i bias è fondamentale per noi. Come sistema, Hubert è più coerente nella valutazione rispetto a una persona. I nostri modelli sono addestrati usando molti revisori esperti con background diversi. Inoltre, Hubert non usa informazioni come genere, età, etnia, religione o aspetto, che sono fonti comuni di bias nei colloqui tradizionali."
                },
                {
                    "q": "Posso fare il colloquio con una persona invece che con Hubert?",
                    "a": "Contatta l’azienda presso cui ti sei candidato per richiedere questa possibilità."
                },
                {
                    "q": "Hubert è un essere umano?",
                    "a": "No, Hubert è un sistema informatico per la conduzione e l’analisi dei colloqui."
                },
                {
                    "q": "Posso modificare le mie risposte più tardi?",
                    "a": "No, proprio come in un colloquio reale, non puoi modificare le risposte una volta inviate."
                },
                {
                    "q": "Come posso dare il meglio nel colloquio Hubert?",
                    "a": "Leggi bene le domande prima di rispondere. Segui le istruzioni. Porta esempi reali dalla tua esperienza e sii onesto."
                },
                {
                    "q": "Ho bisogno di un lavoro, chi devo contattare?",
                    "a": "Contatta l’azienda presso cui ti sei candidato."
                },
                {
                    "q": "Ho fatto il colloquio ma non ho ancora ricevuto notizie. Cosa devo fare?",
                    "a": "Il recruiter decide i prossimi step in base alla valutazione di Hubert e al proprio giudizio. Può essere una telefonata, un test o un colloquio finale. Se altri candidati sono più adatti, la candidatura può essere rifiutata. Puoi contattare il recruiter per chiedere aggiornamenti sulla tua candidatura."
                },
                {
                    "q": "Ho molta esperienza, ma non ho ottenuto il lavoro. Perché?",
                    "a": "La concorrenza può essere alta, con molti candidati qualificati. Se la tua candidatura è stata rifiutata, puoi contattare l’azienda per chiedere il motivo. Puoi anche consultare My Hubert per vedere il feedback sulle tue risposte e scoprire altre opportunità."
                },
                {
                    "q": "Quanto dura il colloquio?",
                    "a": "Dipende dal numero di domande impostate dal recruiter. Di solito dura tra 10 e 25 minuti. Non avere fretta. Puoi fare una pausa e continuare più tardi se necessario."
                },
                {
                    "q": "Dove posso leggere come vengono gestiti i miei dati?",
                    "a": "https://www.hubert.ai/candidate-privacy-policy"
                }
            ],
            "TechnicalSupport": [
                {
                    "q": "Perché non vedo i miei colloqui precedenti con Hubert?",
                    "a": "Assicurati di aver usato lo stesso indirizzo email per candidarti e per accedere a My Hubert. Vale anche per l’accesso con Google: l’email di Google deve coincidere con quella della candidatura. Prova a creare un account con l’email che hai usato per candidarti."
                },
                {
                    "q": "Perché non ho ricevuto l’email per il mio colloquio?",
                    "a": "Controlla la cartella spam. Puoi anche aggiungere hubert@hubert.ai ai tuoi contatti. In alternativa, crea un account My Hubert (usando l’email della candidatura) per trovare lì il link al colloquio."
                },
                {
                    "q": "Non riesco a trovare il link al colloquio nell’email.",
                    "a": "Controlla la cartella spam. In alternativa, crea un account My Hubert (usando l’email della candidatura) e vai su \"I miei colloqui\" per trovare il link."
                },
                {
                    "q": "Il colloquio funziona su dispositivi mobili?",
                    "a": "Sì. Tuttavia, se ti trovi meglio a scrivere da computer, ti consigliamo di usarlo."
                },
                {
                    "q": "Il colloquio non funziona, cosa devo fare?",
                    "a": "Ci dispiace. Scrivici a hubert@hubert.ai e ti aiuteremo."
                },
                {
                    "q": "Voglio eliminare il mio account su My Hubert, cosa devo fare?",
                    "a": "Scrivici a hubert@hubert.ai e ti aiuteremo."
                },
                {
                    "q": "Il colloquio si è interrotto, come posso riprenderlo?",
                    "a": "Clicca il link nell’email di invito per tornare al punto in cui avevi interrotto, oppure accedi a My Hubert e seleziona il colloquio in 'I miei colloqui'."
                }
            ]
        }
    },
    "LearnWithHubert": {
        "BannerSection": {
            "Title": "Impara con Hubert",
            "Subtitle": "Scopri come aumentare le tue possibilità nel processo di selezione e come fare meglio al lavoro.",
            "Label_Search": "cerca guide su colloqui e carriera",
            "ButtonText_Search": "Cerca"
        },
        "TabSelector": {
            "MyFeed": "Il mio feed",
            "InterviewGuides": "Guide ai colloqui",
            "CareerGuides": "Guide di carriera"
        },
        "NewestOnTheFeed": "Novità nel feed",
        "PickedForMe": "Ultimi articoli",
        "InterviewGuides": "Guide ai colloqui",
        "CareerGuides": "Guide di carriera"
    },
    "Article": {
        "ButtonText_BackToAllArticles": "Torna a tutti gli articoli"
    },
    "ForgotPassword": {
        "ResetLinkAlert_Title": "Reimposta la password",
        "ResetLinkAlert_Subtitle": "Clicca sul link di reimpostazione inviato alla tua email per impostare una nuova password e accedere al tuo account.",
        "PasswordNotSetAlert_Message": "Password non impostata, accedi usando ",
        "ResetYourPassword": {
            "MainTitle": "Visualizza i risultati del tuo colloquio con Hubert",
            "Subtitle": "Accedi per vedere i risultati, ricevere feedback, leggere consigli e molto altro.",
            "FormSectionTitle": "Reimposta la password",
            "Label_NewPassword": "Nuova password",
            "Label_ConfirmNewPassword": "Conferma nuova password",
            "Error_NewPassword_Required": "Inserisci una nuova password.",
            "Error_Password_6_Characters": "La nuova password deve contenere almeno 6 caratteri.",
            "Error_ConfirmNewPassword_Required": "Devi confermare la nuova password.",
            "Error_ConfirmNewPassword_NotMatch": "La password non corrisponde alla nuova password.",
            "Error_MalformedResetUrl": "Codice di sicurezza non valido. Riprova.",
            "Error_ResetPasswordFailed": "Abbiamo avuto un problema nel reimpostare la password. Riprova.",
            "Error_WeakPassword": "La password deve contenere almeno 6 caratteri.",
            "Error_InvalidCode_Title": "La richiesta di reimpostazione password è scaduta o non è valida.",
            "Error_InvalidCode_Subtitle": "Prova a reimpostare la password di nuovo.",
            "ButtonText_SetNewPassword": "Imposta nuova password e accedi",
            "ButtonText_RememberYourPassword": "Ricordi la password?",
            "ButtonText_SignInInstead": "Accedi invece"
        }
    },
    "PageNotFound": {
        "Title": "Pagina non trovata",
        "Description": "Sembra che la pagina che cerchi non esista.",
        "ButtonText_GoToDashboard": "Vai alla Dashboard",
        "ButtonText_GoToLogin": "Vai all’accesso"
    },
    "OldInterviewRedirectionModal": {
        "DescriptionLine1": "Il riutilizzo delle risposte non è ancora disponibile per questo colloquio. Prevediamo di introdurre presto questa funzionalità, ma puoi comunque completare il colloquio ora.",
        "DescriptionLine2": "Prosegui con il colloquio cliccando il pulsante qui sotto.",
        "ButtonText_TakeMeToTheInterview": "Portami al colloquio"
    },
    "UnsubscribeFromEmails": {
        "Title": "Sei sicuro?",
        "Subtitle": "Non riceverai più email da noi su questa posizione:",
        "SelectTheReason": "Seleziona un motivo tra le opzioni qui sotto.",
        "ReasonText1": "Ho trovato un altro lavoro.",
        "ReasonText2": "Non mi interessa più questa posizione.",
        "ReasonText3": "Altro",
        "ButtonText_Unsubscribe": "Annulla l’iscrizione per questa posizione",
        "Placeholder_YourReason": "Il tuo motivo",
        "Success_Title": "Hai annullato l’iscrizione alle email su questa posizione.",
        "Loading": "Caricamento...",
        "Error_YourReason_Required": "Inserisci un motivo.",
        "Error_ServerIssue": "Annullamento non riuscito per un errore del server."
    },
    "SocialLoginCallback": {
        "ButtonText_TryAgain": "Riprova"
    },
    "Outreach": {
        "CandidateNotFound": "Candidato non trovato",
        "CandidateNotFoundDesc": "Non siamo riusciti a trovare i dettagli del colloquio che cerchi.",
        "InterviewEnded": "Colloquio terminato",
        "InterviewEndedDesc1": "Questa sessione di colloquio è terminato o non è più disponibile.",
        "InterviewEndedDesc2": "Grazie per il tuo tempo. Se hai domande, contatta il team di selezione.",
        "ReadyTitle": "Pronto per il tuo colloquio, {{firstName}}?",
        "InvitationDesc": "Hubert, per conto di {{companyName}}, ti invita a un colloquio via chat. Il completamento richiede circa 1–2 minuti.",
        "Button_StartChat": "Inizia il colloquio in chat",
        "CancelNotice": "Iniziare qui annullerà la chiamata programmata per questo ruolo.",
        "PreferNotToContinue": "Non vuoi continuare?",
        "DeclineLabel": "Non sono interessato a questa posizione. Vi chiedo di non contattarmi più in merito a questo ruolo.",
        "Button_ConfirmAndDecline": "Conferma e rifiuta",
        "Processing": "Elaborazione...",
        "Toast_DeclineSuccess": "Colloquio rifiutato.",
        "Toast_CancelVoiceInfo": "Chiamata annullata. Funzionalità in arrivo.",
        "Toast_CancelError": "Impossibile annullare il colloquio. Riprova.",
        "Footer_WithdrawConsent": "Puoi revocare il consenso in qualsiasi momento. Scopri di più nell’",
        "Footer_PrivacyPolicySuffix": "informativa sulla privacy di ",
        "Footer_And": " e ",
        "Footer_HubertPrivacyLink": "Informativa sulla privacy e Termini e condizioni di Hubert",
        "Chat_InterviewWith": "Colloquio con {{companyName}}",
        "Chat_StatusConnected": "Connesso",
        "Chat_StatusError": "Errore",
        "Chat_StatusDisconnected": "Disconnesso",
        "Chat_StatusConnecting": "Connessione in corso...",
        "Chat_ReadyToStart": "Pronto a iniziare il colloquio?",
        "Chat_ButtonStart": "Inizia colloquio",
        "Chat_SayHello": "Scrivi ciao per iniziare la conversazione.",
        "Chat_EmptyState": "Invia un messaggio per iniziare il colloquio.",
        "Chat_SelectLanguage": "Scegli la tua lingua preferita",
        "Chat_Placeholder": "Scrivi il tuo messaggio...",
        "Chat_ButtonSend": "Invia",
        "Chat_ButtonBack": "Indietro",
        "LoadingCandidateDetails": "Caricamento dei dettagli del candidato...",
        "FetchingCandidateDetails": "Recupero dei dettagli del candidato...",
        "Chat_StatusReady": "In attesa di connessione...",
        "Chat_ForbiddenError": "Questa chat per il colloquio non è più disponibile.",
        "Chat_GeneralError": "Impossibile avviare la chat. Riprova più tardi.",
        "Chat_SelectUiLanguage": "Lingua dell’interfaccia",
        "Chat_InterviewTitle": "Colloquio di lavoro"
    }
}
